import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Shippment } from '../../models/shippment/shippment-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class SiteMapsService {
  private service = "api/SiteMap"; //Controller Name

  constructor(private http: Http, private readonly router: Router,
    private cookieService: CookieService) {

  }
  GetSitemapTypes() {
    return this.http.get(`${this.service}/GetSitemaps`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GenrateProductSiteMap()
  {
    return this.http.get(`${this.service}/GenrateProductsSiteMap`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GenrateBlogsSiteMap() {
    return this.http.get(`${this.service}/GenrateBlogsSiteMap`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GenratePublicSiteMap() {
    return this.http.get(`${this.service}/GenratePublicSiteMap`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GenrateImageSiteMap() {
    return this.http.get(`${this.service}/GenrateImageSiteMap`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GenrateSitemaps() {
    return this.http.get(`${this.service}/GenrateAllSiteMap`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sitemap/site-maps.service.ts